import axios from "axios";
import { getAccessToken, getRefreshToken, setTokens, clearTokens, emitAuthExpired } from "./token-store";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:4000/api";

export const api = axios.create({ baseURL: API_BASE_URL });

api.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Routes that should never trigger a refresh-and-retry (avoids infinite loops).
const AUTH_EXEMPT = ["/auth/login", "/auth/signup", "/auth/refresh", "/auth/google", "/auth/forgot-password", "/auth/reset-password"];

let refreshPromise = null;

const refreshTokens = async () => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) throw new Error("No refresh token available");
  const { data } = await axios.post(`${API_BASE_URL}/auth/refresh`, { refreshToken });
  setTokens({ accessToken: data.accessToken, refreshToken: data.refreshToken });
  return data;
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;
    const isExempt = AUTH_EXEMPT.some((path) => config?.url?.includes(path));

    if (response?.status === 401 && !isExempt && !config._retried && getRefreshToken()) {
      config._retried = true;
      try {
        if (!refreshPromise) {
          refreshPromise = refreshTokens().finally(() => {
            refreshPromise = null;
          });
        }
        await refreshPromise;
        return api(config);
      } catch (refreshError) {
        clearTokens();
        emitAuthExpired();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

export const getErrorMessage = (error, fallback = "Something went wrong") =>
  error?.response?.data?.message || error?.message || fallback;
